module.exports = __webpack_public_path__ + "img/mobile-small.6c78bedd.svg";